import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { theme } from '@/theme';
export const Container = styled(Box)`
  width: 100vw;
`;
export const BreadcrumbWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `};
`;
export const ImageWrapper = styled(Box)`
  position: relative;
  height: 221px;
  ${theme.media.md.up} {
    height: 320px;
  }
`;
export const CardsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin-left: auto;
  margin-right: auto;
  ${({ theme }) => css`
    padding: ${theme.spacing(5, 2)};
    gap: ${theme.spacing(5)};
  `}
  ${theme.media.md.up} {
    padding: ${({ theme }) => theme.spacing(8, 5)};
    flex-direction: row;
  }
`;
export const Card = styled(Box)`
  flex: 1;
  width: 100%;
`;
export const Section = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing(2)};
  ${theme.media.md.up} {
    margin-top: ${({ theme }) => theme.spacing(3)};
  }
`;
export const Contact = styled(Box)`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(4)};
    gap: ${theme.spacing(1)};
  `};
`;
export const BoldUnderline = styled.span`
  text-decoration: underline;
  font-weight: 600;
`;
export const Underline = styled.span`
  text-decoration: underline;
`;
export const Pointer = styled.span`
  cursor: pointer;
`;
export const SelectContainer = styled(Box)`
  width: 100%;
  ${theme.media.md.up} {
    max-width: 360px;
  }
`;
